import React from 'react';
import { cn } from '../../lib/utils';

export function Card({ children, className, ...props }) {
  return (
    <div 
      className={cn("bg-brand-white rounded-xl border border-gray-100 card-shadow overflow-hidden", className)} 
      {...props}
    >
      {children}
    </div>
  );
}